import React, { useState } from 'react';
import Avatar from './Avatar';
import UserDetails from './UserDetails';
import Adminprofilesettings from '../../Adminprofilesettings'; // Import the dialog content
import { Box, Card, CardContent, CardHeader, Divider, Button, IconButton, Dialog, DialogTitle, DialogContent } from '@mui/material';
import Key from "../../../../clientVariables.json";
import { Edit } from '@mui/icons-material'; // Edit icon
import { userSelector } from "../../../user-redux/selector";
import { useDispatch, useSelector } from "react-redux";
import Recruterprofile from '../../Recruiterprofile';
import Candidateprofile from '../../Candidateprofile';
import CandidateProfiles from '../../../Benchcandidates/Profiles/CandidateProfiles';
const ProfileSection = ({ }) => {

    const { user } = useSelector(userSelector);
    // const [openDialog, setOpenDialog] = useState(false);
    const [isEditClicked, setIsEditClicked] = useState(false); // State to control rendering




    // Render the content dynamically based on the usertype
    const renderDialogContent = () => {
        if (user?.usertype == 6) {
            return <Candidateprofile setIsEditClicked={setIsEditClicked} />;
        } else if (user?.usertype == 3) {
            return <Recruterprofile setIsEditClicked={setIsEditClicked} />;
        } else if (user?.usertype == 7 || user?.usertype == 13) {
            return <Adminprofilesettings setIsEditClicked={setIsEditClicked} />;
        } else {
            return <p>No Settings Available for this User Type</p>;
        }
    };
    // Toggle the visibility of the content when the edit button is clicked
    const handleEditClick = () => {
        //console.log("Edit clicked");
        setIsEditClicked(true); // Toggle the state
    };
    return (

        <Card elevation={3} sx={{ borderRadius: 4 }}>

            {/* Header with gradient background */}
            <CardHeader
                action={<Button onClick={handleEditClick} sx={{ color: "white" }}>     <Edit /></Button>}
                sx={{
                    background: 'linear-gradient(to right, #42a5f5, #1e88e5)',
                    height: 128,
                    mb: -6,
                }}
            />

            {/* Content Section */}
            <CardContent sx={{ paddingTop: 4 }}>
                {/* Edit Icon */}

                {/* Avatar */}

                <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: '-40px' }}>
                    <Avatar
                        alt={user?.full_name || "User Avatar"}
                        // src={user?.avatarUrl || ""}
                        src={`${Key.aws_bucket_profile}/attachments/user_${user?.id}/profileimages/${user?.image}`} />
                </Box>

                {/* User Details */}
                <Box sx={{ marginTop: 2 }}>
                    <UserDetails />
                </Box>
                {isEditClicked && (
                    <Box sx={{ marginTop: 4 }}>
                        {renderDialogContent()}
                    </Box>
                )}
            </CardContent>

            {/* Dialog Box */}
            {/* <Dialog open={openDialog} onClose={handleCloseDialog} fullWidth>
                {renderDialogContent()}
            </Dialog> */}



            <Divider />
        </Card>
    );
};

export default ProfileSection;
